import { Button, Grid } from "@material-ui/core";
import { Save } from "@material-ui/icons";
import React from "react";
//import { useHistory } from 'react-router-dom';


const GuardarYSalirBtn = props => {

    const { click, disabled, moveLeft, agregar, clickAgregar } = props

    const getPadding = () => {
        if (moveLeft) {
            return 18
        } else {
            return 0
        }
    }

    //const history = useHistory();

    return (
        <Grid container item xs={12} justifyContent='flex-end' spacing={2}
            style={{ marginTop: 40, flexBasis: '0%', marginBottom: 10, paddingRight: getPadding() }}
        >

            {agregar ?
                <Grid item xs={2}>
                    <Button
                        variant='outlined'
                        color='secondary'
                        fullWidth
                        onClick={() => {

                            clickAgregar()
                        }}
                    >

                        Agregar

                    </Button>

                </Grid>
                :
                null
            }
            <Grid item xs={2}>
                <Button
                    disabled={disabled ? true : false}
                    variant='outlined'
                    color='primary'
                    fullWidth
                    onClick={() => {
                        //history.push('/fichas_tecnicas')
                        click()
                    }}
                >
                    <Save style={{ marginRight: 10 }} />
                    Guardar


                </Button>

            </Grid>
        </Grid>
    )

}

export default GuardarYSalirBtn